import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'

export default class IntersectionGroup extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        this.items = []
        this.queue = []
        this.timer = null

        this.render = throttle(::this.render, 100)
    }

    prepare() {
        this.items = this.add(this.ref.items)

        this.mutationObserver = new MutationObserver(this.handleMutation)
        this.mutationObserver.observe(this.element, {
            attributes: false,
            childList: true,
            subtree: true
        })

        EventBus.on('CalendarExpand:expand', this.handleExpand)
    }

    destroy() {
        this.items.forEach(item => item && item.destroy())
        this.mutationObserver.disconnect()
        this.mutationObserver = null
    }

    handleMutation = () => {
        this.refresh()
    }

    handleExpand = () => {
        this.refresh()
    }

    handleItemEnter = element => {
        this.queue.push(element)
        this.render()
    }

    refresh() {
        this.ref = {
            items: []
        }

        const items = this.ref.items
            .filter(element => !element['__positionObserver__'])

        this.add(items)
    }

    update() {
        this.ref.items
            .map(element => element['__positionObserver__'])
            .forEach(observer => observer.resize())
    }

    add(elements = []) {
        return elements
            .filter(element => window.getComputedStyle(element).getPropertyValue('display') != 'none')
            .map(element => {
            const observer = new PositionObserver(element, {
                onEnter: () => this.handleItemEnter(element)
            })

            element['__positionObserver__'] = observer

            return observer
        })
    }

    render = () => {
        const queue = this.queue.map((element, index) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    element.classList.add('has-displayed')
                    resolve(element)
                }, 100 * index)
            })
        })

        this.queue = []

        Promise.all(queue)
            .then(elements => {
                elements.forEach(element => {
                    const observer = this.items.find(item => item.element === element)

                    if (observer) {
                        observer.destroy()
                    }
                })
            })
    }

}